"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1654))
 * @trackcomponent
 * @lastsynced 2025-04-11T14:43:35.015Z
 * @optimized using svgo:^3.0.2
 */
export const Settings = createSVGIcon(
  <path
    d="m8.957 3.859.751-1.913A1.71 1.71 0 0 1 11.304.857h1.392a1.71 1.71 0 0 1 1.596 1.089l.75 1.913 2.487 1.436 2.031-.308a1.71 1.71 0 0 1 1.742.838l.696 1.2a1.71 1.71 0 0 1-.144 1.927l-1.283 1.613v2.87l1.283 1.606a1.715 1.715 0 0 1 .144 1.93l-.696 1.2a1.71 1.71 0 0 1-1.742.839l-2.031-.309-2.486 1.437-.751 1.913a1.715 1.715 0 0 1-1.596 1.089h-1.392a1.71 1.71 0 0 1-1.596-1.09l-.75-1.912L6.47 18.7l-2.031.309a1.71 1.71 0 0 1-1.742-.838l-.696-1.2a1.715 1.715 0 0 1 .144-1.927l1.283-1.61v-2.87L2.146 8.96a1.71 1.71 0 0 1-.144-1.93l.696-1.2a1.71 1.71 0 0 1 1.742-.842l2.031.308zM8.571 12a3.429 3.429 0 1 0 6.857 0 3.429 3.429 0 0 0-6.857 0Z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Settings",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Settings",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.default,
  })
);
